/**
 * Default trigger button for EvidenceSettingsPopover.
 */

import { cn } from '@/lib/cn';
import { PopoverTrigger } from '@heidi/design-system/popover';
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@heidi/design-system/tooltip';
import { Settings2 } from 'lucide-react';

export const DefaultTrigger = () => (
  <TooltipProvider delayDuration={300}>
    <Tooltip>
      <TooltipTrigger asChild>
        <PopoverTrigger asChild>
          <button
            type="button"
            className={cn(
              'flex size-8 items-center justify-center rounded-lg transition-all duration-200',
              'text-text-tertiary hover:text-text-secondary',
              'hover:bg-surface-hover',
              'active:scale-95'
            )}
            aria-label="Evidence settings"
          >
            <Settings2 size={18} />
          </button>
        </PopoverTrigger>
      </TooltipTrigger>
      <TooltipContent side="top" sideOffset={8}>
        <TooltipArrow />
        Evidence settings
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
